import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast, Toaster } from "react-hot-toast";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFirefoxBrowser,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa"; // Import the necessary React Icons
import Header from "../common/Header";
import Footer from "../common/Footer";
import { server } from "../server"; // Ensure this points to your backend server URL
import Headerstart from "../common/Headerstart";
import { FaXTwitter } from "react-icons/fa6";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    project: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    for (const key in formData) {
      if (!formData[key]) {
        toast.error(
          `${key.charAt(0).toUpperCase() + key.slice(1)} is required`
        );
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const toastId = toast.loading("Sending message...");

    try {
      const response = await fetch(`${server}/send-contact-message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      toast.dismiss(toastId);

      if (response.ok) {
        toast.success(
          "Message sent successfully! We will get back to you soon.",
          { duration: 10000 }
        );
        setFormData({
          name: "",
          email: "",
          phone: "",
          project: "",
          subject: "",
          message: "",
        });
      } else {
        toast.error("Failed to send your message.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while sending your message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster />
      <Header />
      <Headerstart link={"Contact Us"} />

      <div className="container-fluid contact py-5">
        <div className="container py-5">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-5 text-capitalize text-primary mb-3">
              Contact Us
            </h1>
            <p className="mb-0">
              For inquiries or feedback, please reach out to us using the
              contact form below or through our provided contact details. We
              look forward to hearing from you!
            </p>
          </div>
          <div className="row g-5">
            <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
              <div className="row g-5">
                {/* Address, Email, Phone, Website */}
                <div className="col-md-6 col-lg-6 col-xl-3">
                  <div className="contact-add-item p-4">
                    <div className="contact-icon mb-4">
                      <FaMapMarkerAlt className="fa-2x" />
                    </div>
                    <div>
                      <h4>Address</h4>
                      <p className="mb-0">Limuru Town, Nairobi, Kenya</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  <div className="contact-add-item p-4">
                    <div className="contact-icon mb-4">
                      <FaEnvelope className="fa-2x" />
                    </div>
                    <div>
                      <h4>Mail Us</h4>
                      <p className="mb-0">stewardcars@gmail.com</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  <div className="contact-add-item p-4">
                    <div className="contact-icon mb-4">
                      <FaPhoneAlt className="fa-2x" />
                    </div>
                    <div>
                      <h4>Telephone</h4>
                      <p className="mb-0">(+254) 713 624 100</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                  data-wow-delay="0.7s"
                >
                  <div className="contact-add-item p-4">
                    <div className="contact-icon mb-4">
                      <FaFirefoxBrowser className="fa-2x" />
                    </div>
                    <div>
                      <h4>Website</h4>
                      <p className="mb-0">www.steward.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="bg-secondary p-5 rounded">
                <h4 className="text-primary mb-4">Send Your Message</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input
                          type="tel"
                          className="form-control"
                          id="phone"
                          name="phone"
                          placeholder="Phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                        <label htmlFor="phone">Your Phone</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="project"
                          name="project"
                          placeholder="Project"
                          value={formData.project}
                          onChange={handleChange}
                        />
                        <label htmlFor="project">Your Project</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          name="subject"
                          placeholder="Subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                        <label htmlFor="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Leave a message here"
                          id="message"
                          name="message"
                          style={{ height: "160px" }}
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-light w-100 py-3"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send Message"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-12 col-xl-1 wow fadeInUp" data-wow-delay="0.3s">
              <div className="d-flex flex-xl-column align-items-center justify-content-center">
                <Link
                  className="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-4 me-4 me-xl-0"
                  to=""
                >
                  <FaFacebookF />
                </Link>
                <Link
                  className="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-4 me-4 me-xl-0"
                  to=""
                >
                  <FaXTwitter />
                </Link>
                <Link
                  className="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-4 me-4 me-xl-0"
                  to=""
                >
                  <FaInstagram />
                </Link>
                <Link
                  className="btn btn-xl-square btn-light rounded-circle mb-0 mb-xl-0 me-0 me-xl-0"
                  to=""
                >
                  <FaLinkedinIn />
                </Link>
              </div>
            </div>
            <div className="col-12 col-xl-5 wow fadeInUp" data-wow-delay="0.1s">
              <div className="p-5 bg-light rounded">
                <div className="bg-white rounded p-4 mb-4">
                  <h4 className="mb-3">Our Branch 01</h4>
                  <div className="d-flex align-items-center flex-shrink-0 mb-3">
                    <p className="mb-0 text-dark me-2">Address:</p>
                    <FaMapMarkerAlt className="text-primary me-2" />
                    <p className="mb-0">Nairobi, Kenya</p>
                  </div>
                  <div className="d-flex align-items-center">
                    <p className="mb-0 text-dark me-2">Telephone:</p>
                    <FaPhoneAlt className="text-primary me-2" />
                    <p className="mb-0">(+254) 713 624 100</p>
                  </div>
                </div>
                {/* Repeat for other branches as needed */}
              </div>
            </div>
            <div className="col-12">
              <div className="rounded">
                <iframe
                  className="rounded w-100"
                  style={{ height: "400px" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7978.144055320084!2d36.641793371164155!3d-1.1082109365883597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f27425c8e7e93%3A0xe2d75968641cf56f!2sSteward%20Cars!5e0!3m2!1sen!2ske!4v1737976736441!5m2!1sen!2ske"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="stewardcars"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
